import * as React from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import * as PropTypes from 'prop-types';

const Captcha = forwardRef(({onVerify}, ref) => {
  const hCaptchaRef = useRef(null);

  useImperativeHandle(ref, () => ({
    execute: () => hCaptchaRef.current.execute(),
    reset: () => hCaptchaRef.current.resetCaptcha(),
  }));

  return (
    <div>
      <HCaptcha
        ref={hCaptchaRef}
        theme="dark"
        size="invisible"
        sitekey={RECAPTCHA_SITE_KEY}
        onVerify={captchaToken => onVerify(captchaToken)}
        onExpired={() => hCaptchaRef.current.resetCaptcha()}
      />
    </div>
  );
});

Captcha.propTypes = {
  onVerify: PropTypes.func.isRequired,
};

Captcha.displayName = 'Captcha';

export default Captcha;
